export default "__VITE_ASSET__Byvpgm9___"